<template>
	<div class="snippet" data-title=".dot-falling">
          <div class="stage">
            <div class="dot-falling"></div>
          </div>
    </div>
</template>
<script>
	export default {
	    name: 'Chart-loader',
	    data() {
	        return {}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/chart-loader.vue